import React from 'react';
import { collapseStructurePreview, stepLengthSecs, stepTargetRange, type ApiStructBlock } from '../utils/workoutStructure';

/** Mini interval profile bar for calendar workout rows and week-strip cells. */
export function WorkoutStructureBarMini({
  structure,
  width = 160,
  height = 22,
  onDark = false,
}: {
  structure: { structure?: ApiStructBlock[] } | null | undefined;
  width?: number;
  height?: number;
  /** Lighter bars on the selected (pink gradient) week-strip pill. */
  onDark?: boolean;
}) {
  const blocks = structure?.structure ?? [];
  if (!blocks.length) return null;

  const steps = collapseStructurePreview(blocks);
  if (!steps.length) return null;

  const totalDur = steps.reduce((sum, step) => sum + stepLengthSecs(step.length), 0);
  if (!totalDur) return null;

  const scaleMax = Math.max(
    100,
    ...steps.flatMap((step) => {
      const { min, max } = stepTargetRange(step);
      return [min, max];
    }),
  );

  const W = width;
  const H = height;
  let xCursor = 0;
  const bars: React.ReactNode[] = [];

  steps.forEach((step, i) => {
    const dur = stepLengthSecs(step.length);
    if (!dur) return;
    const w = Math.max((dur / totalDur) * W, 2);
    const { min, max } = stepTargetRange(step);
    const mid = (min + max) / 2;
    const barH = Math.max((mid / scaleMax) * H, 2);
    bars.push(
      <rect
        key={i}
        x={xCursor}
        y={H - barH}
        width={Math.max(w - 0.5, 1)}
        height={barH}
        fill={onDark ? '#b8bec8' : '#8b929e'}
        opacity={onDark ? 0.82 : 0.55}
        rx={1}
      />,
    );
    xCursor += w;
  });

  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="ltr-island" aria-hidden>
      {bars}
    </svg>
  );
}
